export const langEn = {
  'common.expected_finish': 'Expected Finish',
  'common.minutes': 'min',
  'common.seconds': 'sec',
  'common.now': 'Now',
  'common.next': 'Next',
  'common.scheduled_start': 'Scheduled start',
  'common.scheduled_end': 'Scheduled end',
  'common.expected_start': 'Expected start',
  'common.expected_end': 'Expected end',
  'common.timer_message': 'Timer message',
  'common.secondary_message': 'Secondary message',
  'common.stage_timer': 'Stage Timer',
  'common.started_at': 'Started At',
  'common.time_now': 'Time now',
  'common.no_data': 'No data',
  'countdown.skipped': 'Skipped',
  'countdown.data_error': 'Could not load this view. Please refresh the page.',
  'countdown.no_events_description': 'Add events in the editor, then choose what to show here.',
  'countdown.empty_description': 'Choose events to show here.',
  'countdown.choose_events': 'Choose events',
  'countdown.cancel_selection': 'Cancel',
  'countdown.clear': 'Clear',
  'countdown.selected': 'selected',
  'countdown.group': 'Group',
  'countdown.no_title': 'Untitled',
  'countdown.save': 'Save',
  'countdown.edit': 'Edit',
  'countdown.ended': 'Event ended at',
  'countdown.running': 'Event running',
  'countdown.group_running': 'Event in group running',
  'countdown.loaded': 'Event loaded',
  'countdown.select_event': 'Select an event to follow',
  'countdown.to_start': 'Time to start',
  'countdown.waiting': 'Waiting for event start',
  'countdown.overtime': 'in overtime',
  'countdown.all_have_finished': 'All selected events have finished',
  'timeline.live': 'live',
  'timeline.done': 'done',
  'timeline.due': 'due',
  'timeline.followedby': 'Followed by',
  'timeline.standby': 'Standby',
  'project.title': 'Title',
  'project.description': 'Description',
  'project.info': 'Project Info',
  'project.url': 'Project URL',
};

export type TranslationObject = Record<keyof typeof langEn, string>;
